import React, { useState } from 'react';
import DialogBox from '../Common/Layout/DialogBox';
import { Box } from '@mui/material';
import CancelButton from '../Common/Buttons/CancelButton';
import SaveButton from '../Common/Buttons/SaveButton';
import InputComponent from '../Common/Fields/InputComponent';
import { AddCircle } from '@mui/icons-material';
import { Colors } from '../../utils/theme';
import EpraChip from '../Common/Fields/EpraChip';
import { validEmailRegex } from '../../utils/ui';

interface IProps {
  onClose: () => void;
  setCcRecipients: (rec: string[]) => void;
  recientsInput: string[];
}

const CcInput: React.FunctionComponent<IProps> = ({
  onClose,
  setCcRecipients,
  recientsInput
}: IProps) => {
  const buttonSize = 30;
  const [emailValue, setEmailValue] = useState('');
  const [recipients, setRecipients] = useState<string[]>(recientsInput);
  const isValidEmail = emailValue.match(validEmailRegex);

  const addRecipient = () => {
    if (isValidEmail && !recipients.includes(emailValue)) {
      setRecipients([...recipients, emailValue]);
      setEmailValue('');
    }
  };

  return (
    <DialogBox id="cc-dialog" width={640} onClose={onClose} title="Add bcc recipients">
      <Box sx={{ p: '5%', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Box sx={{ display: 'flex', gap: '8px' }}>
          <InputComponent
            id="invoice-email-receiver"
            data-testid="invoice-email-receiver"
            label="Email"
            value={emailValue}
            onChange={(e) => setEmailValue(e.currentTarget.value)}
          />
          <AddCircle
            onClick={addRecipient}
            style={{
              color: isValidEmail ? Colors.skyBlue : Colors.dark_gray,
              height: buttonSize,
              width: buttonSize,
              cursor: isValidEmail ? 'pointer' : ''
            }}
          />
        </Box>
        <Box>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {recipients.map((recipient, index) => (
              <EpraChip
                key={`${recipient}-form-chip-${index}`}
                id={`${recipient}-form-chip-${index}`}
                label={recipient}
                onDelete={() => setRecipients(recipients.filter((r) => r !== recipient))}
              />
            ))}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CancelButton id="cancel-cc-button" onClick={onClose} text="cancel" />
          <SaveButton
            id="save-cc-button"
            onClick={() => {
              setCcRecipients(recipients);
              onClose();
            }}
            text="finish"
          />
        </Box>
      </Box>
    </DialogBox>
  );
};

export default CcInput;
